import * as React from 'react';
import { LabSimAppUrl } from '../Environment';

interface IDemoAccessProps {

}

interface IDemoAccessState {
    tether?: string;
}

export default class DemoTestLocalHost extends React.PureComponent<IDemoAccessProps, IDemoAccessState> {
    constructor(props: IDemoAccessProps) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        window.onmessage = (e: MessageEvent) => {
            window.location.assign("https://localhost.testout.com:3001");
        }

        let tether = encodeURIComponent(btoa(`{"login":"demoaccess_b02b2800-8ea8-4419-af5d-5603734fb16c","pHash":"9855a609b205ca5d7566e189d76bc4067ae1b963024bd9f7de4694f27e33f7ed","source":"${window.location.protocol}//${window.location.host}","sales_contact":""}`));
        this.setState({ tether: `https://localhost.testout.com:3001/?tetheredstart=${tether}`});
    }

    render() {
        return <div>
            <div className="spinner-border text-warning" style={{ "width": "10rem", "height": "10rem", "position": "absolute", "left": "calc(50% - 80px)", "top": "calc(50% - 125px)" }} role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <iframe src={this.state.tether} style={{ "display": "none" }} />
        </div>;
    }
}